export { default as connectClearAll } from './clear-all/connectClearAll.js';
export {
  default as connectCurrentRefinedValues,
} from './current-refined-values/connectCurrentRefinedValues.js';
export {
  default as connectHierarchicalMenu,
} from './hierarchical-menu/connectHierarchicalMenu.js';
export { default as connectHits } from './hits/connectHits.js';
export {
  default as connectHitsPerPage,
} from './hits-per-page/connectHitsPerPage.js';
export {
  default as connectInfiniteHits,
} from './infinite-hits/connectInfiniteHits.js';
export { default as connectMenu } from './menu/connectMenu.js';
export {
  default as connectNumericRefinementList,
} from './numeric-refinement-list/connectNumericRefinementList.js';
export {
  default as connectNumericSelector,
} from './numeric-selector/connectNumericSelector.js';
export {
  default as connectPagination,
} from './pagination/connectPagination.js';
export {
  default as connectPriceRanges,
} from './price-ranges/connectPriceRanges.js';
export {
  default as connectRangeSlider,
} from './range-slider/connectRangeSlider.js';
export { default as connectRange } from './range/connectRange.js';
export {
  default as connectRefinementList,
} from './refinement-list/connectRefinementList.js';
export { default as connectSearchBox } from './search-box/connectSearchBox.js';
export {
  default as connectSortBySelector,
} from './sort-by-selector/connectSortBySelector.js';
export {
  default as connectStarRating,
} from './star-rating/connectStarRating.js';
export { default as connectStats } from './stats/connectStats.js';
export { default as connectToggle } from './toggle/connectToggle.js';
export {
  default as connectBreadcrumb,
} from './breadcrumb/connectBreadcrumb.js';
export { default as connectGeoSearch } from './geo-search/connectGeoSearch.js';
export { default as connectConfigure } from './configure/connectConfigure.js';



// WEBPACK FOOTER //
// ./src/connectors/index.js